import {IColorChangeable} from '../../Interfaces';

declare let THREE: any;

export class Curve extends (THREE.Line as { new(geometry, material): any; }) implements IColorChangeable {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(90));
  private static direction = new THREE.Vector3(1, 0, 0);
  static readonly Name = 'curve';

  private readonly curve;

  constructor(size: number) {

    const geometry = new THREE.BufferGeometry();

    const material = new THREE.LineBasicMaterial({color: 0x000000});

    super(geometry, material);

    this.name = Curve.Name;

    this.curve = new THREE.EllipseCurve(
      0, 0,
      size, size,
      0, 0,
      false,
      0
    );
  }

  update(startPoint, endPoint) {
    const vec = endPoint.clone().sub(startPoint).normalize();
    const sign = vec.dot(new THREE.Vector3(0, 0, -1)) >= 0 ? -1 : 1;
    const angle = vec.angleTo(Curve.direction);
    if (sign < 0) {
      this.curve.aStartAngle = -angle;
      this.curve.aEndAngle = 0;
    } else {
      this.curve.aStartAngle = 0;
      this.curve.aEndAngle = angle;
    }
    const points = this.curve.getPoints(50);
    this.geometry.setFromPoints(points)
      .applyMatrix(Curve.rotationTransform);
  }

  setColor(color): void {
    this.material.color.copy(color);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Angle/Curve.ts